export default {
  'storeValueCard.title': 'チャージカード',
  'storeValueCard.current_balance': '現在残高',
  'storeValueCard.currency': '円',
  'storeValueCard.online_top_up': 'オンラインチャージ',
  'storeValueCard.deduct': '支払い',
  'storeValueCard.transaction_history': '取引履歴',
  'storeValueCard.update_time': '更新日時',
  'storeValueCard.total_amount': '金額',
  'storeValueCard.store': '店舗',
  'storeValueCard.empty': '取引履歴はありません',
  'storeValueCard.redeem.title': '支払い',
  'storeValueCard.redeem.enter_amount': '支払い金額を入力してください',
  'storeValueCard.redeem.enter_store_code': '利用コードを入力してください',
  'storeValueCard.redeem.next_step': '次へ',
  'storeValueCard.redeem.success': '支払いに成功しました',
  'storeValueCard.redeem.fail': '支払いに失敗しました',
  'storeValueCard.description.title': 'ご利用案内',
  'storeValueCard.store.title': 'オンラインチャージ',
  'storeValueCard.store.coupon_alt': 'チャージクーポン',
  'storeValueCard.store.amount_prefix': 'チャージ金 {name}',
  'storeValueCard.store.description': 'オンラインカード決済でチャージを完了すると、各店舗でご利用いただけます',
  'storeValueCard.store.top_up': 'チャージ',
  'storeValueCard.store.empty': 'ブランドでチャージ金額が設定されていません',
} as Record<string, string>;
